import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils';
export const Chip = ({ className, children }) => {
    return (_jsx("div", { className: cn('px-4 py-2 rounded-full text-sm w-fit text-nowrap', 'bg-white border-gray-100 border text-gray-800', className), children: children }));
};
